import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-176018df"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "channel-description"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "latest-messages-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ver todos", -1))
const _hoisted_6 = { class: "latest-messages" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_8 = {
  key: 3,
  class: "latest-messages-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ver todos", -1))
const _hoisted_10 = { class: "latest-messages" }
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_12 = {
  key: 4,
  class: "latest-messages-container"
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelHeader from '@/components/channel/ChannelHeader.vue'
import CodeBite from '@/components/cards/CodeBite.vue'
import CodePost from '@/components/cards/CodePost.vue'
import ProfileService from '@/services/ProfileService'
import ChannelService from '@/services/ChannelService'
import { ref, onMounted , Ref} from 'vue'
import { useAuth } from '@/store/useAuth'
import router from '@/router'
import {useRoute} from 'vue-router'
import BackBtn from '@/components/buttons/BackBtn.vue'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialProfileView',
  setup(__props) {

const profileService = new ProfileService()
const user = ref()
const loading = ref(true)
const store = useAuth()
const codebites:Ref<any> = ref([])
const codeposts:Ref<any> = ref([])
const channelService = new ChannelService()
const route = useRoute()
const nickname = route.params.nickname

onMounted(async () => {
    loading.value = true
    user.value = await profileService.GetUserByNickname(nickname)
    if(isObjectEmpty(user.value)) {
        router.push({name:'error404'})
    }
    codebites.value = await channelService.GetLatestCodeBites(user.value.id, 4)
    codeposts.value = await channelService.GetLatestCodePosts(user.value.id, 2)
    loading.value = false
})

const refresh = async () => {
    if (!store.token) { return }
    codebites.value = await channelService.GetLatestCodeBites(store.token, 4)
    codeposts.value = await channelService.GetLatestCodePosts(store.token, 2)
}

function isObjectEmpty(obj:any) {
  return Object.keys(obj).length === 0;
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (user.value)
        ? (_openBlock(), _createBlock(ChannelHeader, {
            key: 0,
            user: user.value
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h3", null, "Sobre " + _toDisplayString(user.value.name), 1),
            (user.value.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(user.value.description), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_3, "Bienvenido al canal de " + _toDisplayString(user.value.name) + " en " + _toDisplayString(_unref(main).NAME_COMPANY_FOOTER), 1))
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h3", null, [
              _createTextVNode("Últimos Shorts de " + _toDisplayString(user.value.name) + " ", 1),
              _createVNode(_component_RouterLink, {
                to: { name: 'social-codebites', params: {nickname: _unref(nickname)} },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codebites.value, (codebite) => {
                return (_openBlock(), _createBlock(CodeBite, {
                  key: codebite.id,
                  codebite: codebite,
                  user: user.value,
                  onRefresh: refresh
                }, null, 8, ["codebite", "user"]))
              }), 128)),
              (codebites.value.length == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(user.value.name) + " no ha publicado Shorts", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h3", null, [
              _createTextVNode("Últimos Posts de " + _toDisplayString(user.value.name) + " ", 1),
              _createVNode(_component_RouterLink, {
                to: { name: 'social-codeposts', params: {nickname: _unref(nickname)} },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeposts.value, (codepost) => {
                return (_openBlock(), _createBlock(CodePost, {
                  key: codepost.id,
                  codepost: codepost,
                  user: user.value,
                  onRefresh: refresh
                }, null, 8, ["codepost", "user"]))
              }), 128)),
              (codeposts.value.length == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(user.value.name) + " no ha publicado Posts", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(BackBtn)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})